/* eslint-disable react-hooks/exhaustive-deps */
import { createStyles, FormControl, FormControlLabel, FormLabel, IconButton, makeStyles, Radio, RadioGroup, Theme } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { ChartCommonProps, IconButtonWrapper } from '../Common';
import { ChartFilter } from '../ChartComponents';
// import { SearchCriteria } from '../SearchCriteria';
import CloseIcon from '@material-ui/icons/Close';
import { convertStringNumberToNumber, formatNumber, getLabels, getMaxTickLimit, getSuggestedMaxTick } from '../../helpers/ChartHelper';
// import { DrillDownType } from '../DrillDownType';
import { SelectedItemProps } from '../MattersByStatusChart';
import gql from 'graphql-tag';
import { useQuery } from 'react-apollo';
import { Bar, getElementAtEvent } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, Scale, Tick, Chart, ChartEvent, ActiveElement } from 'chart.js';
import zoomPlugin from 'chartjs-plugin-zoom';
import { useTranslation } from 'react-i18next';
import { TranslationTextList } from '../../locales/common';
import { ChartInfo } from '../../components/ChartInfo';
import GetAppOutlinedIcon from '@material-ui/icons/GetAppOutlined';
import { useScreenshot, createFileName } from 'use-react-screenshot';
import MTooltip from '@material-ui/core/Tooltip';
import AspectRatioIcon from '@material-ui/icons/AspectRatio';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';

import { RV_CHART_CLASS, RV_CHART_COLORS, isChartDataEmpty, rvBarDatasetStyle, rvChartAnimation, rvCategoryAxisStyle, rvTooltipStyle, rvValueAxisStyle } from '../chartTheme';
import { ChartHeading } from '../ChartHeading';
import { ChartSkeleton } from '../../components/loading/ChartSkeleton';
import { AnimatedNumber } from '../AnimatedNumber';
import { ChartEmptyState } from '../ChartEmptyState';
import ReceiptOutlinedIcon from '@material-ui/icons/ReceiptOutlined';
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, zoomPlugin);

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            position: 'relative',
            paddingBottom: '10px',
            flex: 1,
            display: 'flex',
            flexFlow: 'column',
            maxWidth: '100%',
            maxHeight: '100%',
            height: '100%',
            textAlign: 'center',
            '@media print': {
                display: 'flex',
                flexFlow: 'column',
                alignItems: 'center',
                boxShadow: 'none !important',
            },
        },
        popover: {},
        paper: {},
        radioGroup: {
            flexFlow: 'row wrap',
            justifyContent: 'center',
        },
        closeIcon: {
            color: 'rgb(0, 120, 212)',
        },
        titleContainer: {
            display: 'flex',
            flexFlow: 'column',
            padding: '20px 15px 0px 15px',
        },
        barContainer: {
            padding: '5px 15px 15px 15px',
            minHeight: '300px',
            flex: 1,
            display: 'flex',
            flexFlow: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            maxHeight: '350px',
            maxWidth: 'auto',
            position: 'relative',
            '@media (max-width: 533px)': {
                maxWidth: '350px',
                margin: '0 auto',
            },
            '& .titleWrapper': {
                textAlign: 'center',
                display: 'inline-block',
                width: '100%',
                padding: '15px',
                '& .title': {
                    fontSize: '18px',
                    fontWeight: 600,
                    display: 'block',
                    marginBottom: '15px',
                },
                '& .value': {
                    fontSize: '24px',
                    fontWeight: 600,
                    display: 'block',
                    marginBottom: '15px',
                },
                '& .secondary-title': {
                    fontSize: '16px',
                    fontWeight: 400,
                    display: 'block',
                    marginBottom: '15px',
                },
            },
        },
        loadingWrapper: {
            padding: '20px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
        },
        title: {
            fontSize: 16,
            fontWeight: 600,
            fontFamily: 'inherit',
            marginBottom: 0,
        },
        totalDiv: {
            cursor: 'pointer',
            paddingRight: 5,
        },
        total: {
            fontSize: '2.5rem',
            padding: '10px 0',
            fontWeight: 600,
            cursor: 'pointer',
        },
        span: {
            fontSize: '1rem',
        },
        helpIcon: {
            position: 'absolute',
            left: '5px',
            top: '5px',
            '@media print': {
                display: 'none !important',
            },
        },
        formControl: {
            display: 'flex',
            flexFlow: 'row wrap',
            alignItems: 'center',
            justifyContent: 'center',
        },
        formLabel: {
            marginRight: '10px',
        },
        scrollUp: {
            position: 'absolute',
            top: '30px',
            justifyContent: 'center',
            transform: 'translateX(-50%)',
            left: '50%',
            minWidth: '54px',
        },
        scrollDown: {
            position: 'absolute',
            bottom: '90px',
            justifyContent: 'center',
            transform: 'translateX(-50%)',
            left: '50%',
            minWidth: '54px',
        }
    }),
);

export enum BillingByGroupOptionEnum {
    SOURCE = 0,
    ASSIGNEE,
    AREA_OF_LAW,
    LOCATION,
    EVENT_CAMPAIGN
}

export enum BillingByGroupIncludeEnum {
    LAST_3_MONTHS = 0,
    LAST_6_MONTHS,
    LAST_12_MONTHS,
    ALL_TIME,
}

interface CrmMatterBillingChartProps extends SelectedItemProps, ChartCommonProps {
    chartFilter?: ChartFilter;
    // groupBy: 'PersonActing' | 'PersonAssisting' | 'PersonResponsible';
}

interface ChartState {
    options: BillingByGroupOptionEnum;
    include: BillingByGroupIncludeEnum;
    matterBillingByGroup: MatterBillingByGroup[];
    totalBilling: number;
    enquiriesWonCount: number;
    symbol: string;
}

export const CrmMatterBillingChart: React.FC<CrmMatterBillingChartProps> = (props) => {
    const classes = useStyles();

    // tslint:disable-next-line:no-any
    const chartRef = React.useRef<any>();

    // tslint:disable-next-line:no-any
    const entireChartRef = React.useRef<any>();

    // tslint:disable-next-line:no-any
    const scrollUpAndPrevRef = React.useRef<any>();

    // tslint:disable-next-line:no-any
    const scrollDownAndNextRef = React.useRef<any>();

    const { t } = useTranslation() as {
        t: (key: keyof TranslationTextList) => string;
    };

    const [state, setState] = useState<ChartState>({
        options: BillingByGroupOptionEnum.SOURCE,
        include: BillingByGroupIncludeEnum.LAST_3_MONTHS,
        matterBillingByGroup: [],
        totalBilling: 0,
        enquiriesWonCount: 0,
        symbol: '$',
    });

    const takeScreenShot = useScreenshot({
        type: 'image/jpeg',
        quality: 1.0
    })[1];

    // tslint:disable-next-line:no-any
    const matterBillingQuery = useQuery<MatterBillingData>(MATTER_BILLING_QUERY, {
        variables: {
            // groupBy: props.groupBy,
            entityType: props.chartFilter?.entityType,
            entityGuid: props.chartFilter?.entityGuid,
            showAllRecords: props.showAllRecords
        },
        fetchPolicy: 'no-cache',
    });

    const currencySymbolQuery = useQuery<CurrencySymbolData>(CURRENCY_SYMBOL_QUERY);

    useEffect(() => {
        if (currencySymbolQuery.data && currencySymbolQuery.data.options && !currencySymbolQuery.loading && !currencySymbolQuery.error) {
            setState((prevState) => {
                return {
                    ...prevState,
                    symbol: currencySymbolQuery.data!.options.currencySymbol.symbol,
                };
            });
        }

        // tslint:disable-next-line: align
    }, [currencySymbolQuery.loading, currencySymbolQuery.error, currencySymbolQuery.data]);

    useEffect(() => {
        setState((prevState) => {
            let matterBillingByGroup: MatterBillingByGroup[] = [];
            let totalBilling: number = 0;
            let enquiriesWonCount: number = 0;

            if (matterBillingQuery.data && matterBillingQuery.data.statistics && matterBillingQuery.data.statistics.lead && matterBillingQuery.data.statistics.lead.matterBilling) {
                // tslint:disable-next-line: max-line-length
                const {
                    matterBillingBySource,
                    matterBillingByAssignees,
                    matterBillingByLocation,
                    matterBillingByAreaOfLaw,
                    matterBillingByEventAndCampaign,
                    matterBillingTotalLast3Months,
                    matterBillingTotalLast6Months,
                    matterBillingTotalLast12Months,
                    matterBillingTotalAll,
                } = matterBillingQuery.data.statistics.lead.matterBilling;
                if (state.options === BillingByGroupOptionEnum.SOURCE) {
                    const { matterBillingBySourceLast3Months, matterBillingBySourceLast6Months, matterBillingBySourceLast12Months, matterBillingBySourceAll } =
                        matterBillingBySource;

                    if (state.include === BillingByGroupIncludeEnum.LAST_3_MONTHS) {
                        matterBillingByGroup = matterBillingBySourceLast3Months.matterBillingByGroup;
                        totalBilling = matterBillingTotalLast3Months.totalBilling;
                        enquiriesWonCount = matterBillingTotalLast3Months.enquiriesWonCount;
                    } else if (state.include === BillingByGroupIncludeEnum.LAST_6_MONTHS) {
                        matterBillingByGroup = matterBillingBySourceLast6Months.matterBillingByGroup;
                        totalBilling = matterBillingTotalLast6Months.totalBilling;
                        enquiriesWonCount = matterBillingTotalLast6Months.enquiriesWonCount;
                    } else if (state.include === BillingByGroupIncludeEnum.LAST_12_MONTHS) {
                        matterBillingByGroup = matterBillingBySourceLast12Months.matterBillingByGroup;
                        totalBilling = matterBillingTotalLast12Months.totalBilling;
                        enquiriesWonCount = matterBillingTotalLast12Months.enquiriesWonCount;
                    } else {
                        matterBillingByGroup = matterBillingBySourceAll.matterBillingByGroup;
                        totalBilling = matterBillingTotalAll.totalBilling;
                        enquiriesWonCount = matterBillingTotalAll.enquiriesWonCount;
                    }
                } else if (state.options === BillingByGroupOptionEnum.ASSIGNEE) {
                    const { matterBillingByAssigneesLast3Months, matterBillingByAssigneesLast6Months, matterBillingByAssigneesLast12Months, matterBillingByAssigneesAll } =
                        matterBillingByAssignees;

                    if (state.include === BillingByGroupIncludeEnum.LAST_3_MONTHS) {
                        matterBillingByGroup = matterBillingByAssigneesLast3Months.matterBillingByGroup;
                        totalBilling = matterBillingTotalLast3Months.totalBilling;
                        enquiriesWonCount = matterBillingTotalLast3Months.enquiriesWonCount;
                    } else if (state.include === BillingByGroupIncludeEnum.LAST_6_MONTHS) {
                        matterBillingByGroup = matterBillingByAssigneesLast6Months.matterBillingByGroup;
                        totalBilling = matterBillingTotalLast6Months.totalBilling;
                        enquiriesWonCount = matterBillingTotalLast6Months.enquiriesWonCount;
                    } else if (state.include === BillingByGroupIncludeEnum.LAST_12_MONTHS) {
                        matterBillingByGroup = matterBillingByAssigneesLast12Months.matterBillingByGroup;
                        totalBilling = matterBillingTotalLast12Months.totalBilling;
                        enquiriesWonCount = matterBillingTotalLast12Months.enquiriesWonCount;
                    } else {
                        matterBillingByGroup = matterBillingByAssigneesAll.matterBillingByGroup;
                        totalBilling = matterBillingTotalAll.totalBilling;
                        enquiriesWonCount = matterBillingTotalAll.enquiriesWonCount;
                    }
                } else if (state.options === BillingByGroupOptionEnum.AREA_OF_LAW) {
                    const { matterBillingByAreaOfLawLast3Months, matterBillingByAreaOfLawLast6Months, matterBillingByAreaOfLawLast12Months, matterBillingByAreaOfLawAll } =
                        matterBillingByAreaOfLaw;

                    if (state.include === BillingByGroupIncludeEnum.LAST_3_MONTHS) {
                        matterBillingByGroup = matterBillingByAreaOfLawLast3Months.matterBillingByGroup;
                        totalBilling = matterBillingTotalLast3Months.totalBilling;
                        enquiriesWonCount = matterBillingTotalLast3Months.enquiriesWonCount;
                    } else if (state.include === BillingByGroupIncludeEnum.LAST_6_MONTHS) {
                        matterBillingByGroup = matterBillingByAreaOfLawLast6Months.matterBillingByGroup;
                        totalBilling = matterBillingTotalLast6Months.totalBilling;
                        enquiriesWonCount = matterBillingTotalLast6Months.enquiriesWonCount;
                    } else if (state.include === BillingByGroupIncludeEnum.LAST_12_MONTHS) {
                        matterBillingByGroup = matterBillingByAreaOfLawLast12Months.matterBillingByGroup;
                        totalBilling = matterBillingTotalLast12Months.totalBilling;
                        enquiriesWonCount = matterBillingTotalLast12Months.enquiriesWonCount;
                    } else {
                        matterBillingByGroup = matterBillingByAreaOfLawAll.matterBillingByGroup;
                        totalBilling = matterBillingTotalAll.totalBilling;
                        enquiriesWonCount = matterBillingTotalAll.enquiriesWonCount;
                    }
                } else if (state.options === BillingByGroupOptionEnum.LOCATION) {
                    const { matterBillingByLocationLast3Months, matterBillingByLocationLast6Months, matterBillingByLocationLast12Months, matterBillingByLocationAll } =
                        matterBillingByLocation;

                    if (state.include === BillingByGroupIncludeEnum.LAST_3_MONTHS) {
                        matterBillingByGroup = matterBillingByLocationLast3Months.matterBillingByGroup;
                        totalBilling = matterBillingTotalLast3Months.totalBilling;
                        enquiriesWonCount = matterBillingTotalLast3Months.enquiriesWonCount;
                    } else if (state.include === BillingByGroupIncludeEnum.LAST_6_MONTHS) {
                        matterBillingByGroup = matterBillingByLocationLast6Months.matterBillingByGroup;
                        totalBilling = matterBillingTotalLast6Months.totalBilling;
                        enquiriesWonCount = matterBillingTotalLast6Months.enquiriesWonCount;
                    } else if (state.include === BillingByGroupIncludeEnum.LAST_12_MONTHS) {
                        matterBillingByGroup = matterBillingByLocationLast12Months.matterBillingByGroup;
                        totalBilling = matterBillingTotalLast12Months.totalBilling;
                        enquiriesWonCount = matterBillingTotalLast12Months.enquiriesWonCount;
                    } else {
                        matterBillingByGroup = matterBillingByLocationAll.matterBillingByGroup;
                        totalBilling = matterBillingTotalAll.totalBilling;
                        enquiriesWonCount = matterBillingTotalAll.enquiriesWonCount;
                    }
                } else {
                    const { 
                        matterBillingByEventAndCampaignLast3Months, 
                        matterBillingByEventAndCampaignLast6Months, 
                        matterBillingByEventAndCampaignLast12Months, 
                        matterBillingByEventAndCampaignAll } =
                        matterBillingByEventAndCampaign;

                    if (state.include === BillingByGroupIncludeEnum.LAST_3_MONTHS) {
                        matterBillingByGroup = matterBillingByEventAndCampaignLast3Months.matterBillingByGroup;
                        totalBilling = matterBillingTotalLast3Months.totalBilling;
                        enquiriesWonCount = matterBillingTotalLast3Months.enquiriesWonCount;
                    } else if (state.include === BillingByGroupIncludeEnum.LAST_6_MONTHS) {
                        matterBillingByGroup = matterBillingByEventAndCampaignLast6Months.matterBillingByGroup;
                        totalBilling = matterBillingTotalLast6Months.totalBilling;
                        enquiriesWonCount = matterBillingTotalLast6Months.enquiriesWonCount;
                    } else if (state.include === BillingByGroupIncludeEnum.LAST_12_MONTHS) {
                        matterBillingByGroup = matterBillingByEventAndCampaignLast12Months.matterBillingByGroup;
                        totalBilling = matterBillingTotalLast12Months.totalBilling;
                        enquiriesWonCount = matterBillingTotalLast12Months.enquiriesWonCount;
                    } else {
                        matterBillingByGroup = matterBillingByEventAndCampaignAll.matterBillingByGroup;
                        totalBilling = matterBillingTotalAll.totalBilling;
                        enquiriesWonCount = matterBillingTotalAll.enquiriesWonCount;
                    }
                }
            }

            return {
                ...prevState,
                matterBillingByGroup,
                totalBilling,
                enquiriesWonCount,
            };
        });
        // tslint:disable-next-line: align
    }, [matterBillingQuery.data, matterBillingQuery.loading, matterBillingQuery.error, state.options, state.include]);

    const onCloseChart = () => {
        if (props.onCloseChart) {
            props.onCloseChart(`isMatterBillingChartOpen`);
        }
    };

    const onMaximize = () => {
        if (props.onMaximize) {
            props.onMaximize(state.options, state.include);
        }
    };

    // tslint:disable-next-line: no-any
    const onDownload = (name: string, extension: string = 'jpg') => (image: any) => {
        const a = document.createElement('a');
        a.href = image;
        a.download = createFileName(extension, name);
        a.click();
    };

    const onDownloadScreenshot = () => {
        setTimeout(() => {
            takeScreenShot(entireChartRef.current).then(onDownload('Billing by ' + getGroupByTitle(state.options)));
            // tslint:disable-next-line: align
        }, 500);
    };
    
    const chartControllerComponent = () => {
        return (
            <>
                <IconButtonWrapper aria-label="close">
                    <ChartInfo 
                        description={props.description}
                        fontSize={props.showAllRecords ? 'large' : 'medium'}
                        className={`${classes.helpIcon} rv-chart-help`}
                    />
                    {(props.showAllRecords || props.showScreenshot) && (
                        <IconButton
                            size={props.showAllRecords ? 'medium' : 'small'}
                            onClick={onDownloadScreenshot}
                        >
                            <GetAppOutlinedIcon 
                                color="primary" 
                                fontSize={props.showAllRecords ? 'large' : 'medium'}
                            />
                        </IconButton>
                    )}
                    {!props.showAllRecords && props.onMaximize && (
                        <MTooltip title="Expand chart">
                            <IconButton aria-label="maximize" onClick={onMaximize} size="small">
                                <AspectRatioIcon />
                            </IconButton>
                        </MTooltip>
                    )}
                    <IconButton aria-label="close" onClick={onCloseChart} size={props.showAllRecords ? 'medium' : 'small'}>
                        <CloseIcon className={classes.closeIcon} fontSize={props.showAllRecords ? 'large' : 'medium'} />
                    </IconButton>
                </IconButtonWrapper>
            </>
        );
    };


    const handleTotalClick = () => {
        if (props.getSelectedItem) {
            // const searchCriterias = new Array<SearchCriteria>();
            // if (state.include === BillingByGroupIncludeEnum.OVERDUE) {
            //     searchCriterias.push({ property: 'DueDates', operator: 'eq', comparison: 'Overdue' });
            // } else if (state.include === BillingByGroupIncludeEnum.TODAY) {
            //     searchCriterias.push({ property: 'DueDates', operator: 'eq', comparison: 'Today' });
            // } else if (state.include === BillingByGroupIncludeEnum.NEXT_7_DAYS) {
            //     searchCriterias.push({ property: 'DueDates', operator: 'eq', comparison: 'NextSevenDays' });
            // } else if (state.include === BillingByGroupIncludeEnum.NEXT_30_DAYS) {
            //     searchCriterias.push({ property: 'DueDates', operator: 'eq', comparison: 'NextThirtyDays' });
            // } else {
            //     searchCriterias.push({ property: 'DueDates', operator: 'eq', comparison: 'All' });
            // }
            // const _tempTitle = `due dates ${getIncludeByTitle(state.include).toLowerCase()} breakdown by ${getGroupByTitle(
            //     state.options,
            // ).toLowerCase()}`;
            // props.getSelectedItem(searchCriterias, true, _tempTitle, DrillDownType.matterSummaryDrilldown, 'Matters');
        }
    };

    const onChangeRadio = (event: React.ChangeEvent<HTMLInputElement>) => {
        const fieldName = event.target.name;
        setState((prevState) => {
            return {
                ...prevState,
                // tslint:disable-next-line: radix
                [fieldName]: parseInt((event.target as HTMLInputElement).value),
            };
        });
    };

    const getIncludeByTitle = (include: BillingByGroupIncludeEnum) => {
        if (include === BillingByGroupIncludeEnum.LAST_3_MONTHS) {
            return 'Last 3 months';
        } else if (include === BillingByGroupIncludeEnum.LAST_6_MONTHS) {
            return 'Last 6 months';
        } else if (include === BillingByGroupIncludeEnum.LAST_12_MONTHS) {
            return 'Last 12 months';
        } else {
            return 'All time';
        }
    };

    const getGroupByTitle = (option: BillingByGroupOptionEnum) => {
        if (option === BillingByGroupOptionEnum.SOURCE) {
            return 'Source';
        } else if (option === BillingByGroupOptionEnum.ASSIGNEE) {
            return 'Assignee';
        } else if (option === BillingByGroupOptionEnum.AREA_OF_LAW) {
            return 'Area of Law';
        } else if (option === BillingByGroupOptionEnum.LOCATION) {
            return 'Location';
        } else {
            return 'Event & Campaign';
        }
    };

    const onPan = (context: { chart: Chart }) => {
        chartRef.current.options.scales.x.min = 0;
        chartRef.current.update();
    };

    const onHover = (event: ChartEvent, elements: ActiveElement[], chart: Chart) => {
        (event?.native?.target as HTMLElement).style.cursor = elements.length > 0 ? 'pointer' : 'auto';
    };
    
    if (matterBillingQuery.loading) {
        return (
            <ChartSkeleton variant="bars" />
        );
    }

    let chartLabels = state.matterBillingByGroup.map((billingByGroup: MatterBillingByGroup) => billingByGroup.groupedBy);
    let chartData = state.matterBillingByGroup.map((billingByGroup: MatterBillingByGroup) => billingByGroup.feesBilled);

    const onScrollUpAndPrev = (type: 'up' | 'prev') => {
        if (chartRef.current.options.scales[type === 'up' ? 'y' : 'x'].min > 0) {
            const scrollRatio = chartRef.current.options.scales[type === 'up' ? 'y' : 'x'].max - chartRef.current.options.scales[type === 'up' ? 'y' : 'x'].min;
            const min = chartRef.current.options.scales[type === 'up' ? 'y' : 'x'].min;
            if (scrollRatio < chartRef.current.options.scales[type === 'up' ? 'y' : 'x'].min) {
                chartRef.current.options.scales[type === 'up' ? 'y' : 'x'].min -= scrollRatio ? scrollRatio : 1;
                chartRef.current.options.scales[type === 'up' ? 'y' : 'x'].max -= scrollRatio ? scrollRatio : 1;
            } else {
                chartRef.current.options.scales[type === 'up' ? 'y' : 'x'].min -= min;
                chartRef.current.options.scales[type === 'up' ? 'y' : 'x'].max -= min;
            }
            chartRef.current.options.scales[type === 'up' ? 'x' : 'y'].min = 0;
            chartRef.current.update();
            // enabled scroll up
            scrollUpAndPrevRef.current.classList.remove('Mui-disabled');
        } else {
            // disabled scroll up
            scrollUpAndPrevRef.current.classList.add('Mui-disabled');
        }
        scrollDownAndNextRef.current.classList.remove('Mui-disabled');
    };

    const onScrollDownAndNext = (type: 'down' | 'next') => {

        const labels = getGroupByTitle(state.options);

        if (chartRef.current.options.scales[type === 'down' ? 'y' : 'x'].max < labels.length) {
            const remainingBar = labels.length - chartRef.current.options.scales[type === 'down' ? 'y' : 'x'].max;
            const scrollRatio = chartRef.current.options.scales[type === 'down' ? 'y' : 'x'].max - chartRef.current.options.scales[type === 'down' ? 'y' : 'x'].min;
            if (remainingBar <= scrollRatio) {
                chartRef.current.options.scales[type === 'down' ? 'y' : 'x'].min += remainingBar;
                chartRef.current.options.scales[type === 'down' ? 'y' : 'x'].max += remainingBar;
            } else {
                chartRef.current.options.scales[type === 'down' ? 'y' : 'x'].min += scrollRatio ? scrollRatio : 1;
                chartRef.current.options.scales[type === 'down' ? 'y' : 'x'].max += scrollRatio ? scrollRatio : 1;
            }
            chartRef.current.options.scales[type === 'down' ? 'x' : 'y'].min = 0;
            chartRef.current.update();
            // enabled scroll down
            scrollDownAndNextRef.current.classList.remove('Mui-disabled');
        } else {
            // disabled scroll down
            scrollDownAndNextRef.current.classList.add('Mui-disabled');
        }
        scrollUpAndPrevRef.current.classList.remove('Mui-disabled');
    };

    const onScollBar = (type: 'up' | 'down' | 'prev' | 'next') => () => {
        if (type === 'up') {
            onScrollUpAndPrev('up');
        } else if (type === 'down') {
            onScrollDownAndNext('down');
        } else if (type === 'next') {
            onScrollDownAndNext('next');
        } else {
            onScrollUpAndPrev('prev');
        }
    };

    return (
        <div className={`${classes.root} ${RV_CHART_CLASS}${isChartDataEmpty(chartData) ? ' rv-chart--empty' : ''}`}>
            {chartControllerComponent()}
            <div className={classes.titleContainer}>
                <ChartHeading icon={<ReceiptOutlinedIcon />} title={<>Billing by {getGroupByTitle(state.options)}</>} />
                <div className={`${classes.total} h2`} onClick={handleTotalClick}>
                    <AnimatedNumber value={state.totalBilling} format={(amount) => `${state.symbol}${formatNumber(amount)}`} />
                </div>
                <div className={classes.title}>
                    {/* {`${state.enquiriesWonCount} ${t('enquiries')} won  */}
                    {getIncludeByTitle(state.include)}
                </div>
            </div>
            <div className={classes.barContainer} style={{ maxHeight: props.showAllRecords ? '100%' : '350px' }}>
                {props.showAllRecords && (
                    <>
                        <div className={`${classes.scrollUp} scroll`}>
                            <IconButton
                                size="medium"
                                onClick={onScollBar('up')}
                                ref={scrollUpAndPrevRef}
                            >
                                <KeyboardArrowUpIcon color="primary" fontSize="large" />
                            </IconButton>
                        </div>
                        <div className={`${classes.scrollDown} scroll`}>
                            <IconButton
                                size="medium"
                                onClick={onScollBar('down')}
                                ref={scrollDownAndNextRef}
                            >
                                <KeyboardArrowDownIcon color="primary" fontSize="large" />
                            </IconButton>
                        </div>
                    </>
                )}
                <Bar
                    ref={chartRef}
                    // tslint:disable-next-line: no-any
                    onClick={(event: React.MouseEvent<any>) => {
                        const _data = getElementAtEvent(chartRef.current, event);
                        if (_data.length > 0 && props.getSelectedItem) {
                            // const _index = getElementAtEvent(chartRef.current, event)[0].index;

                            // const item = state.matterBillingByGroup.map((billingByGroup: MatterBillingByGroup) => billingByGroup.groupedBy)[_index];

                            // const searchCriterias = new Array<SearchCriteria>();
                            // if (state.options === BillingByGroupOptionEnum.PERSON_ACTING) {
                            //     searchCriterias.push({ property: 'Acting', operator: 'eq', comparison: item });
                            // } else if (state.options === BillingByGroupOptionEnum.PERSON_ASSISTING) {
                            //     searchCriterias.push({ property: 'Assisting', operator: 'eq', comparison: item });
                            // } else {
                            //     searchCriterias.push({ property: 'Responsible', operator: 'eq', comparison: item });
                            // }
                            // if (state.include === BillingByGroupIncludeEnum.OVERDUE) {
                            //     searchCriterias.push({ property: 'DueDates', operator: 'eq', comparison: 'Overdue' });
                            // } else if (state.include === BillingByGroupIncludeEnum.TODAY) {
                            //     searchCriterias.push({ property: 'DueDates', operator: 'eq', comparison: 'Today' });
                            // } else if (state.include === BillingByGroupIncludeEnum.NEXT_7_DAYS) {
                            //     searchCriterias.push({ property: 'DueDates', operator: 'eq', comparison: 'NextSevenDays' });
                            // } else if (state.include === BillingByGroupIncludeEnum.NEXT_30_DAYS) {
                            //     searchCriterias.push({ property: 'DueDates', operator: 'eq', comparison: 'NextThirtyDays' });
                            // } else {
                            //     searchCriterias.push({ property: 'DueDates', operator: 'eq', comparison: 'All' });
                            // }
                            // const _tempTitle = `${item} due dates ${getIncludeByTitle(state.include).toLowerCase()} breakdown by ${getGroupByTitle(
                            //     state.options,
                            // ).toLowerCase()}`;
                            // props.getSelectedItem(searchCriterias, true, _tempTitle, DrillDownType.matterSummaryDrilldown, 'Matters');
                        }
                    }}
                    data={{
                        labels: getLabels(chartLabels),
                        datasets: [
                            {
                                label: 'Fees Billed',
                                ...rvBarDatasetStyle(RV_CHART_COLORS.primary),
                                data: chartData,
                            },
                        ],
                    }}
                    options={{
                        onHover: onHover,
                        indexAxis: 'y' as const,
                        animation: rvChartAnimation(),
                        elements: { bar: { borderWidth: 0 } },
                        responsive: true,
                        maintainAspectRatio: false,
                        scales: {
                            x: {
                                grid: rvValueAxisStyle.grid,
                                // beginAtZero: true,
                                suggestedMax: getSuggestedMaxTick(chartData),
                                beginAtZero: true,
                                ticks: {
                                    ...rvValueAxisStyle.ticks,
                                    maxTicksLimit: getMaxTickLimit(chartData),
                                    autoSkip: false,
                                    callback: function (this: Scale, tickValue: number, index: number, ticks: Tick[]) {
                                        return `${state.symbol} ${formatNumber(tickValue)}`;
                                    },
                                },
                            },
                            y: {
                                grid: rvCategoryAxisStyle.grid,
                                // min: 0,
                                // max: 9 // minimum display
                                max: props.showAllRecords ? 29 : 9,
                                ticks: {
                                    ...rvCategoryAxisStyle.ticks,
                                    autoSkip: false,
                                    callback: function (this: Scale, tickValue: string, index: number, ticks: Tick[]) {
                                        if (chartLabels.length > 0) {
                                            const label = chartLabels[index];
                                            if (label) {

                                                if (label.length > 20) {
                                                    return label.substring(0, 20) + '...';
                                                }

                                                return label;
                                            }
                                        }
                                        return '';
                                    }
                                }
                            }
                        },
                        plugins: {
                            legend: {
                                position: 'bottom' as const,
                                display: false,
                            },
                            title: {
                                display: false,
                                text: ``,
                            },
                            zoom: {
                                pan: {
                                    enabled: props.showAllRecords,
                                    onPan: onPan,
                                },
                                zoom: {
                                    wheel: {
                                        enabled: props.showAllRecords
                                    },
                                },
                                // limits: {
                                //   y: { min: 0, max: 9 },
                                // },
                            },
                            tooltip: {
                                ...rvTooltipStyle,
                                callbacks: {
                                    // tslint:disable-next-line: no-any
                                    label: function (context: any) {
                                        const {
                                            //   dataIndex,
                                            //   label,
                                            formattedValue,
                                            dataset,
                                        } = context;

                                        var currentValue = convertStringNumberToNumber(formattedValue);

                                        return `${dataset.label}: ${formatNumber(currentValue)}`;
                                    },
                                    // tslint:disable-next-line: no-any no-shadowed-variable
                                    afterLabel: function (context: any) {
                                        const { dataIndex } = context;
                                        const enquiries = state.matterBillingByGroup
                                            .map((dueDateByGroup: MatterBillingByGroup) => dueDateByGroup.enquiriesCount)[dataIndex];

                                        return `${t('Matters')}: ${formatNumber(enquiries)}`;
                                    },
                                },
                            },
                        },
                    }}
                />
                {isChartDataEmpty(chartData) && (
                    <ChartEmptyState title="No data" hint="Nothing to show for this selection." />
                )}
            </div>
            <FormControl component="div" className={classes.formControl}>
                <FormLabel component="legend" className={classes.formLabel}>
                    Group By
                </FormLabel>
                <RadioGroup name="options" value={state.options} onChange={onChangeRadio} className={classes.radioGroup}>
                    <FormControlLabel value={BillingByGroupOptionEnum.SOURCE} control={<Radio color="primary" />} label="Source" />
                    <FormControlLabel value={BillingByGroupOptionEnum.ASSIGNEE} control={<Radio color="primary" />} label="Assignee" />
                    <FormControlLabel value={BillingByGroupOptionEnum.AREA_OF_LAW} control={<Radio color="primary" />} label="Area of Law" />
                    <FormControlLabel value={BillingByGroupOptionEnum.LOCATION} control={<Radio color="primary" />} label="Location" />
                    <FormControlLabel value={BillingByGroupOptionEnum.EVENT_CAMPAIGN} control={<Radio color="primary" />} label="Event & Campaign" />
                </RadioGroup>
            </FormControl>
            <FormControl component="div" className={classes.formControl}>
                <FormLabel component="legend" className={classes.formLabel}>
                    Include
                </FormLabel>
                <RadioGroup name="include" value={state.include} onChange={onChangeRadio} className={classes.radioGroup}>
                    <FormControlLabel value={BillingByGroupIncludeEnum.LAST_3_MONTHS} control={<Radio color="primary" />} label="Last 3 months" />
                    <FormControlLabel value={BillingByGroupIncludeEnum.LAST_6_MONTHS} control={<Radio color="primary" />} label="Last 6 months" />
                    <FormControlLabel value={BillingByGroupIncludeEnum.LAST_12_MONTHS} control={<Radio color="primary" />} label="Last 12 months" />
                    <FormControlLabel value={BillingByGroupIncludeEnum.ALL_TIME} control={<Radio color="primary" />} label="All time" />
                </RadioGroup>
            </FormControl>
            {/* {state.matterBillingByGroup.length >= 10 && <span className={classes.span}>The top 10 are shown</span>} */}
        </div>
    );
};

export interface CurrencySymbolData {
    options: Options;
}

export interface Options {
    currencySymbol: CurrencySymbol;
}

export interface CurrencySymbol {
    symbol: string;
}

export const CURRENCY_SYMBOL_QUERY = gql`
    query CurrencySymbol {
        options {
            currencySymbol {
                symbol
            }
        }
    }
`;

export interface MatterBillingData {
    statistics: Statistics;
}

export interface Statistics {
    lead: Lead;
}

export interface Lead {
    matterBilling: MatterBilling;
}

export interface MatterBilling {
    matterBillingBySource: MatterBillingBySource;
    matterBillingByAssignees: MatterBillingByAssignees;
    matterBillingByLocation: MatterBillingByLocation;
    matterBillingByAreaOfLaw: MatterBillingByAreaOfLaw;
    matterBillingByEventAndCampaign: MatterBillingByEventAndCampaign;
    matterBillingTotalLast3Months: MatterBillingTotal;
    matterBillingTotalLast6Months: MatterBillingTotal;
    matterBillingTotalLast12Months: MatterBillingTotal;
    matterBillingTotalAll: MatterBillingTotal;
}

export interface MatterBillingByAssignees {
    matterBillingByAssigneesLast3Months: MatterBillingBy;
    matterBillingByAssigneesLast6Months: MatterBillingBy;
    matterBillingByAssigneesLast12Months: MatterBillingBy;
    matterBillingByAssigneesAll: MatterBillingBy;
}

export interface MatterBillingBy {
    matterBillingByGroup: MatterBillingByGroup[];
}

export interface MatterBillingByGroup {
    enquiriesCount: number;
    feesBilled: number;
    groupedBy: string;
}

export interface MatterBillingByLocation {
    matterBillingByLocationLast3Months: MatterBillingBy;
    matterBillingByLocationLast6Months: MatterBillingBy;
    matterBillingByLocationLast12Months: MatterBillingBy;
    matterBillingByLocationAll: MatterBillingBy;
}

export interface MatterBillingByEventAndCampaign {
    matterBillingByEventAndCampaignLast3Months: MatterBillingBy;
    matterBillingByEventAndCampaignLast6Months: MatterBillingBy;
    matterBillingByEventAndCampaignLast12Months: MatterBillingBy;
    matterBillingByEventAndCampaignAll: MatterBillingBy;
}

export interface MatterBillingBySource {
    matterBillingBySourceLast3Months: MatterBillingBy;
    matterBillingBySourceLast6Months: MatterBillingBy;
    matterBillingBySourceLast12Months: MatterBillingBy;
    matterBillingBySourceAll: MatterBillingBy;
}

export interface MatterBillingTotal {
    totalBilling: number;
    enquiriesWonCount: number;
}

export interface MatterBillingByAreaOfLaw {
    matterBillingByAreaOfLawLast3Months: MatterBillingBy;
    matterBillingByAreaOfLawLast6Months: MatterBillingBy;
    matterBillingByAreaOfLawLast12Months: MatterBillingBy;
    matterBillingByAreaOfLawAll: MatterBillingBy;
}

const MATTER_BILLING_QUERY = gql`
    # Write your query or mutation here
    query matterBillingChart($entityType: Int, $entityGuid: String, $showAllRecords: Boolean)  {
        statistics {
            lead {
                matterBilling(entityType: $entityType, entityGuid: $entityGuid, showAllRecords: $showAllRecords) {
                    matterBillingBySource {
                        matterBillingBySourceLast3Months {
                            matterBillingByGroup {
                                enquiriesCount
                                feesBilled
                                groupedBy
                            }
                        }
                        matterBillingBySourceLast6Months {
                            matterBillingByGroup {
                                enquiriesCount
                                feesBilled
                                groupedBy
                            }
                        }
                        matterBillingBySourceLast12Months {
                            matterBillingByGroup {
                                enquiriesCount
                                feesBilled
                                groupedBy
                            }
                        }
                        matterBillingBySourceAll {
                            matterBillingByGroup {
                                enquiriesCount
                                feesBilled
                                groupedBy
                            }
                        }
                    }
                    matterBillingByAssignees {
                        matterBillingByAssigneesLast3Months {
                            matterBillingByGroup {
                                enquiriesCount
                                feesBilled
                                groupedBy
                            }
                        }
                        matterBillingByAssigneesLast6Months {
                            matterBillingByGroup {
                                enquiriesCount
                                feesBilled
                                groupedBy
                            }
                        }
                        matterBillingByAssigneesLast12Months {
                            matterBillingByGroup {
                                enquiriesCount
                                feesBilled
                                groupedBy
                            }
                        }
                        matterBillingByAssigneesAll {
                            matterBillingByGroup {
                                enquiriesCount
                                feesBilled
                                groupedBy
                            }
                        }
                    }
                    matterBillingByLocation {
                        matterBillingByLocationLast3Months {
                            matterBillingByGroup {
                                enquiriesCount
                                feesBilled
                                groupedBy
                            }
                        }
                        matterBillingByLocationLast6Months {
                            matterBillingByGroup {
                                enquiriesCount
                                feesBilled
                                groupedBy
                            }
                        }
                        matterBillingByLocationLast12Months {
                            matterBillingByGroup {
                                enquiriesCount
                                feesBilled
                                groupedBy
                            }
                        }
                        matterBillingByLocationAll {
                            matterBillingByGroup {
                                enquiriesCount
                                feesBilled
                                groupedBy
                            }
                        }
                    }
                    matterBillingByAreaOfLaw {
                        matterBillingByAreaOfLawLast3Months {
                            matterBillingByGroup {
                                enquiriesCount
                                feesBilled
                                groupedBy
                            }
                        }
                        matterBillingByAreaOfLawLast6Months {
                            matterBillingByGroup {
                                enquiriesCount
                                feesBilled
                                groupedBy
                            }
                        }
                        matterBillingByAreaOfLawLast12Months {
                            matterBillingByGroup {
                                enquiriesCount
                                feesBilled
                                groupedBy
                            }
                        }
                        matterBillingByAreaOfLawAll {
                            matterBillingByGroup {
                                enquiriesCount
                                feesBilled
                                groupedBy
                            }
                        }
                    }
                    matterBillingByEventAndCampaign {
                        matterBillingByEventAndCampaignLast3Months {
                            matterBillingByGroup {
                                enquiriesCount
                                feesBilled
                                groupedBy
                            }
                        }
                        matterBillingByEventAndCampaignLast6Months {
                            matterBillingByGroup {
                                enquiriesCount
                                feesBilled
                                groupedBy
                            }
                        }
                        matterBillingByEventAndCampaignLast12Months {
                            matterBillingByGroup {
                                enquiriesCount
                                feesBilled
                                groupedBy
                            }
                        }
                        matterBillingByEventAndCampaignAll {
                            matterBillingByGroup {
                                enquiriesCount
                                feesBilled
                                groupedBy
                            }
                        }
                    }
                    matterBillingTotalLast3Months {
                        totalBilling
                        enquiriesWonCount
                    }
                    matterBillingTotalLast6Months {
                        totalBilling
                        enquiriesWonCount
                    }
                    matterBillingTotalLast12Months {
                        totalBilling
                        enquiriesWonCount
                    }
                    matterBillingTotalAll {
                        totalBilling
                        enquiriesWonCount
                    }
                }
            }
        }
    }
`;
